import { actions } from 'redux/slices/user.slices'
import { type AppDispatch } from 'redux/store'
import type User from 'types/User'

export const initializeUser =
  (user: User) =>
    async (dispatch: AppDispatch): Promise<void> => {
      dispatch(actions.initializeUser(user))
    }
